package meineglasfaser.frontend.www.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.frontend.www.components.sections.RegisterFooter
import meineglasfaser.frontend.www.components.sections.RegisterHeader
import meineglasfaser.frontend.www.components.sections.ShopFooter
import meineglasfaser.frontend.www.components.sections.ShopHeader
import org.jetbrains.compose.web.dom.Main

@Layout
@Composable
fun RegisterLayout(content: @Composable () -> Unit) {
    RegisterHeader()
    Main(attrs = { classes(CONTAINER_CLASS) }) {
        content()
    }
    RegisterFooter()
}
